// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"6bb2c303","381":"adc04cf4","410":"da75554b","472":"059a4f93","823":"61c29da4"}[chunkId] + ".chunk.js";
};